import { DEBUG_BUILD as l } from "./chunk1186.js";
import { getGlobalSingleton as f, GLOBAL_OBJ as s } from "./chunk1079.js";
const g = "Sentry Logger ", c = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], i = {};
function d(n) {
  if (!("console" in s))
    return n();
  const e = s.console, o = {}, t = Object.keys(i);
  t.forEach((r) => {
    const a = i[r];
    o[r] = e[r], e[r] = a;
  });
  try {
    return n();
  } finally {
    t.forEach((r) => {
      e[r] = o[r];
    });
  }
}
function E() {
  let n = !1;
  const e = {
    enable: () => {
      n = !0;
    },
    disable: () => {
      n = !1;
    },
    isEnabled: () => n
  };
  return l ? c.forEach((o) => {
    e[o] = (...t) => {
      n && d(() => {
        s.console[o](`${g}[${o}]:`, ...t);
      });
    };
  }) : c.forEach((o) => {
    e[o] = () => {
    };
  }), e;
}
const b = f("logger", E);
export {
  c as CONSOLE_LEVELS,
  d as consoleSandbox,
  b as logger,
  i as originalConsoleMethods
};
